module.exports = __webpack_public_path__ + "img/appScan.56bee739.png";